import Component from '../abstracts/Component';

export default class PrintComponent extends Component {

  static get SELECTORS() {
    return {
      printBtn: '.js-print'
    };
  }



  bindEvents() {
    $('body').on('click.print', PrintComponent.SELECTORS.printBtn, function(e) {
      window.print();
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
